class ParallaxScroll {
    constructor(options = {}) {
        this.speed = options.speed || 0.5; // Controls scroll intensity
        this.init();
    }

    init() {
        const elements = document.querySelectorAll('.parallax-scroll');

        elements.forEach(element => {
            gsap.to(element, {
                scrollTrigger: {
                    trigger: element,
                    start: 'top bottom',
                    end: 'bottom top',
                    scrub: true, // Smooth scrolling
                },
                y: (i, target) => {
                    // Negative value for opposite direction
                    return -window.innerHeight * this.speed;
                },
                ease: 'none'
            });
        });
    }
}

// Initialize classes
window.addEventListener('load', () => {
    try {
        new ParallaxScroll({ speed: 0.4 }); // Adjust speed as needed
    } catch (error) {
        console.error('Error initializing animations:', error);
    }
});